/*
 * @Descripttion: router
 * @FilePath: /mall-wap-vue/src/router/index.js
 * @Author: 张兴业
 * @Date: 2020-09-24 10:19:31
 * @LastEditors: 张兴业
 * @LastEditTime: 2021-08-19 15:31:43
 */
import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  // scrollBehavior: () => ({ y: 0 }),
  base: "/",
  routes
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

export default router;
